<template>
  <!-- clase move creada para cambiar el cursor a move -->
  <b-row class="grab">
    <b-col class="col-main-pad">
        <b-row>
          <b-col lg="12" class="col-head-activity">
            <font-awesome-icon icon="language" />&nbsp; Configurar Completa la Lectura
          </b-col>
          <b-col lg="12">
            <b-form-group>
              <label for="name">Instrucciones de la Actividad</label>
              <b-form-textarea
                v-model="instrucciones"
                placeholder="Ingrese las Instrucciones para Realizar la Actividad"
                rows="2"
                max-rows="3"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="12">
            <b-form-group>
              <label for="name">Escribe el texto y agrega las frases dentro de corchetes [ ]</label>
              <b-form-textarea
                v-model="lectura"
                placeholder="Ingresa el texto que se mostrará en la actividad"
                rows="2"
                max-rows="3"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
    </b-col>
    <!-- componente de botón de opciones del elemento  -->
    <options-element :index-element="idElement" :index-column="idColumn"></options-element>
  </b-row>
</template>

<script>
import OptionsElement from "./OptionsElement";
export default {
  name: "CompletarFrase",
  components: {
    OptionsElement
  },
  data() {
    return {
      instrucciones: this.desc,
      lectura: this.texto,
      previewActive: false
    };
  },
  props: {
    desc: { type: String },
    idElement: { type: Number },
    texto: { type: String },
    idColumn: { type: Number, default: null }
  },
  methods: {
    test() {
      console.log(this.idElement);
      console.log(this.idColumn);
      console.log(this.instrucciones);
      console.log(this.lectura);
    }
  },
  watch: {
    instrucciones: function(change) {
      this.$store.dispatch("constructor/updateContentElement", {
        indexElement: this.idElement,
        data: change,
        field: "instrucciones",
        indexColumns: this.idColumn
      });
    },
    lectura: function(change) {
      this.$store.dispatch("constructor/updateContentElement", {
        indexElement: this.idElement,
        data: change,
        field: "lectura",
        indexColumns: this.idColumn
      });
    }
  }
};
</script>
<style lang="scss" scoped>
</style>